<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { config } from "@/api/function.js";

export default {
  name: "App",
  components: {},
  mounted() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      config()
        .getSysinfo()
        .then((res) => {
          let info = res.data[0];
          this.$store.commit("user/setCompanyInfo", info);

          document.title = (info.title ? info.title + "-" : "") + this.$route.meta.title;

          if (info.logo && info.logo.length) {
            document.head.querySelectorAll("link").forEach((link) => {
              if (link.rel === "icon") {
                link.parentNode?.removeChild(link);
              }
            });
            const link = document.createElement("link");
            link.rel = "icon";
            link.href = info.logo;
            document.head.append(link);
          }
        });
    },
  },
};
</script>

<style>
body {
  margin: 0;
  font-family: Arial, "Times New Roman", SimHei;
  -webkit-user-select: none;
  /* Safari */
  -moz-user-select: none;
  /* Firefox */
  -ms-user-select: none;
  /* IE10+/Edge */
  user-select: none;
}

div {
  box-sizing: border-box;
}

@import "./assets/css/customCss.scss";
</style>
